import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';

@Component({
  selector: 'cluster-dialog',
  templateUrl: './cluster-dialog.component.html',
  styleUrls: ['./cluster-dialog.component.scss']
})
export class ClusterDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ClusterDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private userPrivilege: UserPrivilegeService) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  elements = [];
  isAuthorized: boolean;

  ngOnInit(): void {
    this.isAuthorized = this.userPrivilege.isAuthorized();
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data.selectedItem);
  }
}
